module.exports = __webpack_public_path__ + "static/media/p1.fd5609d9.jpg";